<template>
  <div>
    <div class="order-pagination">
      <va-pagination
        v-model="currentPage"
        :page-size="5"
        :pages="deliveryData.meta.last_page"
      />
    </div>
    <va-card>
      <va-data-table
        :fields="fields"
        :data="deliveryData.data"
        class="va-table va-table--hoverable va-table--clickable"
        api-mode
      >
        <template slot="number" slot-scope="props">
          <span>{{ props.rowData.id }}</span>
        </template>
        <template slot="data" slot-scope="props">
          <span
            >{{ props.rowData.date_from }} - {{ props.rowData.date_to }}</span
          >
        </template>
        <template slot="time" slot-scope="props">
          <span
            >{{ props.rowData.time_from_boundary }} -
            {{ props.rowData.time_to_boundary }}</span
          >
        </template>
        <template slot="day_markup" slot-scope="props">
          <span>{{ props.rowData.day_markup }}р</span>
        </template>
        <template slot="night_markup" slot-scope="props">
          <span>{{ props.rowData.night_markup }}р</span>
        </template>
        <template slot="time_range_surcharge" slot-scope="props">
          <span>{{ props.rowData.range_time_markup }}p</span>
        </template>
        <template slot="accurate_time_bonus" slot-scope="props">
          <span>{{ props.rowData.exact_time_markup }}р</span>
        </template>
        <template slot="surcharge_per_km" slot-scope="props">
          <span>{{ props.rowData.markup_per_km }}р</span>
        </template>
        <template slot="action" slot-scope="props">
          <va-button
            flat
            small
            color="gray"
            icon="fa fa-pencil"
            @click="editDeliveryHandler(props.rowData)"
          />
          <va-button
            flat
            small
            color="gray"
            icon="fa fa-trash"
            @click="deleteDeliveryHandler(props.rowData.id)"
          />
        </template>
      </va-data-table>
    </va-card>
    <div class="order-pagination">
      <va-pagination
        v-model="currentPage"
        :page-size="5"
        :pages="deliveryData.meta.last_page"
      />
    </div>
    <va-modal
      v-model="showUpdateForm"
      class="delivery-edit-modal"
      hide-default-actions
    >
      <edit-delivery :delivery-data="deliveryInfo" @close="hide" />
    </va-modal>
  </div>
</template>

<script>
import api from "@/api/axios";
import { mapActions } from "vuex";
import editDelivery from "./edit-delivery.vue";
export default {
  name: "DeliveryTable",
  components: { editDelivery },
  props: {
    deliveryData: {
      type: Object,
      require: true,
      default: () => {},
    },
  },
  data() {
    return {
      showUpdateForm: false,
      pageNum: 1,
      deliveryInfo: {},
    };
  },
  computed: {
    fields() {
      return [
        {
          name: "__slot:number",
          title: "Номер",
        },
        {
          name: "__slot:data",
          title: "Дата",
        },
        {
          name: "__slot:time",
          title: "Время",
        },
        {
          name: "__slot:day_markup",
          title: "Дневная стоимость",
        },
        {
          name: "__slot:night_markup",
          title: "Ночная стоимость",
        },
        {
          name: "__slot:time_range_surcharge",
          title: "Надбавка за диапазон времени",
        },
        {
          name: "__slot:accurate_time_bonus",
          title: "Надбавка за точное время",
        },
        {
          name: "__slot:surcharge_per_km",
          title: "Надбавка за км",
        },
        {
          name: "__slot:action",
          title: "",
        },
      ];
    },
    currentPage: {
      get() {
        return this.deliveryData.meta.current_page;
      },
      set(page) {
        this.pageNum = page;
      },
    },
  },
  watch: {
    pageNum() {
      this.updateList({
        page: this.pageNum,
      });
    },
  },
  methods: {
    ...mapActions({
      getDeliverySettings: "delivery/getDeliveryList",
    }),
    editDeliveryHandler(val) {
      if (val.id !== 1) {
        this.showUpdateForm = !this.showUpdateForm;
        this.deliveryInfo = val;
      }
    },
    async deleteDeliveryHandler(id) {
      if (confirm("Вы действительно хотите удалить ?")) {
        try {
          await api.delete(`/admin/delivery-settings/${id}`);
          await this.getDeliverySettings({
            page: this.pageNum,
          });
        } catch (error) {
          return error;
        }
      }
    },
    async updateList(payload) {
      try {
        await this.getDeliverySettings(payload);
      } catch (error) {
        return error;
      }
    },
    hide() {
      this.showUpdateForm = false;
    },
  },
};
</script>
<style lang="scss">
.order-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
